import {
  MessagesSquare,
  House,
  LayoutDashboard,
  Waypoints,
  Rss,
  Shield,
  FileText,
} from "lucide-react";

const isDD = process.env.REACT_APP_IS_DD === "true";
const isII = process.env.REACT_APP_IS_II === "true";
const isCP = process.env.REACT_APP_IS_CP === "true";

// CP shows everything and overrides other variant flags
export const SHOW_WIKI = isCP || !isII;
export const SHOW_APTS = isCP || (!isDD && !isII);
const wikiHasSubItems = isCP || !isDD;
// iso-fork: the new (GS-designed) Graph and Chat UI ships on EVERY build
// variant — the variant flags above still drive branding and wiki/apts
// visibility, but never old-vs-new UI.
export const NEW_UI = true;
// Hides the legacy chat page (nav entry, route, sidebar portal, and every
// link that pointed at it) — the new /threads page replaces it. No legacy
// chat code was removed; flip this to true to bring the page back.
export const SHOW_LEGACY_CHAT = false;

/**
 * Canonical section definitions used by both the sidebar and the navbar.
 *
 * • `path`        – route segment (doubles as currentAppPage value)
 * • `label`       – human-readable name
 * • `Icon`        – Lucide component (capitalized for JSX usage)
 * • `hasSubItems` – whether the section has an expandable portal slot
 */
export const SECTION_DEFS = [
  { path: "/home", label: "Home", Icon: House, hasSubItems: false },
  // The /threads chat page. Its thread history is this section's dropdown
  // (ThreadsSidebarPortal → threads-portal-slot), Feed/Reports-style. The
  // route lives in Main.jsx as usual.
  { path: "/threads", label: "Chat", Icon: MessagesSquare, hasSubItems: true },
  ...(SHOW_LEGACY_CHAT
    ? [
        {
          path: "/chat",
          label: "Chat",
          Icon: MessagesSquare,
          hasSubItems: true,
        },
      ]
    : []),
  ...(SHOW_WIKI
    ? [
        {
          path: "/wiki",
          label: "Wiki",
          Icon: LayoutDashboard,
          hasSubItems: wikiHasSubItems,
        },
      ]
    : []),
  // GS: the greenfield graph page owns its navigation (toolbar preset control),
  // so the sidebar entry is a plain button — no portal dropdown.
  { path: "/graph", label: "Graph", Icon: Waypoints, hasSubItems: !NEW_UI },
  ...(SHOW_APTS
    ? [{ path: "/apts", label: "APTs", Icon: Shield, hasSubItems: false }]
    : []),
  { path: "/reports", label: "Reports", Icon: FileText, hasSubItems: true },
  { path: "/feed", label: "Feed", Icon: Rss, hasSubItems: true },
];

/**
 * Same data but shaped for MainLeftSidebar's `sections` prop
 * (uses `icon` as a JSX element with strokeWidth={1}, not `Icon` as a component).
 */
export const SIDEBAR_SECTIONS = SECTION_DEFS.map((s) => ({
  path: s.path,
  label: s.label,
  icon: <s.Icon strokeWidth={1} />,
  hasSubItems: s.hasSubItems,
}));
